import { useEffect } from 'react'

interface MetaTagsProps {
  title: string
  description: string
  image?: string
  type?: 'website' | 'article'
  canonical?: string
  noIndex?: boolean
  keywords?: string
  locale?: string
}

export const MetaTags = ({
  title,
  description,
  image,
  type = 'website',
  canonical,
  noIndex = false,
  keywords,
  locale = 'tr_TR'
}: MetaTagsProps) => {
  useEffect(() => {
    document.title = `${title} | DersKaynağı`

    setMeta('name', 'description', description)

    if (keywords) {
      setMeta('name', 'keywords', keywords)
    }

    setMeta('property', 'og:type', type)
    setMeta('property', 'og:title', title)
    setMeta('property', 'og:description', description)
    setMeta('property', 'og:locale', locale)

    if (image) {
      setMeta('property', 'og:image', image)
      setMeta('name', 'twitter:card', 'summary_large_image')
      setMeta('name', 'twitter:image', image)
    }

    setMeta('name', 'twitter:title', title)
    setMeta('name', 'twitter:description', description)

    const canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement
    if (canonical) {
      if (canonicalLink) {
        canonicalLink.href = canonical
      } else {
        const link = document.createElement('link')
        link.rel = 'canonical'
        link.href = canonical
        document.head.appendChild(link)
      }
    } else if (canonicalLink) {
      canonicalLink.remove()
    }

    const robotsMeta = document.querySelector('meta[name="robots"]')
    if (noIndex) {
      if (robotsMeta) {
        robotsMeta.setAttribute('content', 'noindex, nofollow')
      } else {
        const meta = document.createElement('meta')
        meta.name = 'robots'
        meta.content = 'noindex, nofollow'
        document.head.appendChild(meta)
      }
    } else if (robotsMeta) {
      robotsMeta.remove()
    }

    return () => {
      const existingCanonical = document.querySelector('link[rel="canonical"]')
      existingCanonical?.remove()

      const existingRobots = document.querySelector('meta[name="robots"]')
      existingRobots?.remove()
    }
  }, [title, description, image, type, canonical, noIndex, keywords, locale])

  return null
}

function setMeta(attrType: 'name' | 'property', attrKey: string, content: string) {
  const selector = attrType === 'name'
    ? `meta[name="${attrKey}"]`
    : `meta[property="${attrKey}"]`

  let meta = document.querySelector(selector) as HTMLMetaElement

  if (!meta) {
    meta = document.createElement('meta')
    meta.setAttribute(attrType, attrKey)
    document.head.appendChild(meta)
  }

  meta.content = content
}
